import axioPath from '../../../api/axioPath';
// import axios from 'axios';
import { UPDATE_DATA } from 'redux/actions/action_types';
import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const createInvApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/inventory/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};

export const createInventoryApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/inventory/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const inventoryUpdate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/inventory/update', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const postInventory = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const searchNearbyInventory = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/search/nearby_inventory', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const recurrenceInventoryValidate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/recurrence/validate', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const placeBidPostInventory = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/bid/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postInventoryById = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postInventory/bid/' + data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const buyerNow = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventoryBuyNow/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const buyerNowOnCPU = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventoryBuyNowCpu/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const prePopulateInventory = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postInventory/list', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const sellerAddresses = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/seller/addresses', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const sellerPrepopulate = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/sellerPostInventoryProfile/get', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const sellerGroupList = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/group/seller/list', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postInventoryDropDownSearch = (params, pageNo, sortOrder, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/search/postInventory/search/nearby?' + params + '&page=' + `${pageNo}` + '&size=12&sort=' + `${sortOrder}` + '&fieldNameSort=created', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postInventoryAdvanceSearch = (params, pageNo, sortOrder, token, searchType) => (dispatch) => {
  dispatch(showAppLoader());
  let url = '/search/postInventory/search?' + params + '&page=' + `${pageNo}` + '&size=12&sort=' + `${sortOrder}` + '&fieldNameSort=created'
  if (searchType === 'advanceSearch') url = '/search/postInventory/adv/search?' + params + '&page=' + `${pageNo}` + '&size=12&sort=' + `${sortOrder}` + '&fieldNameSort=created'
  return axioPath
    .get(url, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postInventorySearch = (title, pageNo, sortOrder, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postInventory/search-pagination?title=' + `${title}` + '&page=' + `${pageNo}` + '&size=9&sort=' + `${sortOrder}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postInventoryRepost = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/repost-with-bid-close', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postInventoryRepostPopup = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/repost', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const getInventorydetailsById = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/inventory/get_inventorydetails_by_id', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const postInventorySearchById = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/inventory/get_inventory_by_id/', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const postInventoryId = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/v2/inventory/' + `${id}`, {
      // .get('/rfp/v2/need/6527a8448edefd4196417176', {
      headers: {
        Authorization: `${token}`,
        authId: 'authId',
        role: 'role'
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};

// export const postInventoryList = (pageNo, size, sort, status, token, searchText, locationFlag) => (dispatch) => {
//   dispatch(showAppLoader());
//   if (status === undefined || status === 'All') {
//     status = ''
//   }

//   if(sort === true){
//     locationFlag=true
//     sort="DESC"
//   }else{
//     locationFlag=false
//   }

//   let url
//   let currentNotifiedItem = localStorage.getItem('currentNotifiedItem')
//   if (currentNotifiedItem !== undefined && currentNotifiedItem !== null && currentNotifiedItem !== '') {
//     url = `/rfp/postInventory/search-pagination-id?page=1&size=10&sort=DESC&id=${currentNotifiedItem}`
//   } else {
//     url = '/rfp/postInventory/list-pageable-innerCircle?page=' + `${pageNo}` + `&size=${size}&sort=` + `${sort}` + '&status=' + `${status}`
//   }
//   localStorage.removeItem('currentNotifiedItem')
//   return axioPath
//     .get('/rfp/postInventory/list-pageable?page=' + `${pageNo}` + '&size=' + `${size}` + '&sort=' + `${sort}` + '&status=' + `${status}` + '&searchBy=' + searchText+ '&locationBy=' + `${locationFlag}`, {
//       headers: {
//         Authorization: `${token}`,
//       },
//     })
//     .then((response) => {
//       setTimeout(
//         () => {
//           dispatch(hideAppLoader());
//         },
//         3000
//       );
//       dispatch({ type: UPDATE_DATA, payload: response.data });
//       return response.data;
//     })
//     .catch((ex) => {
//       dispatch(hideAppLoader());
//       return ex;
//     });
// };
export const postInventoryList = (data, token) => (dispatch) => {
  dispatch(showAppLoader());

  return axioPath
    // .post('/rfp/postInventory/list-pageable', data, {
    .post('/rfp/v2/inventory/my_posted_inventory', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const postInvRecurringListV2 = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/reccuring/post_inventory', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const buyerPostInentoryProfile = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/sellerPostInventoryProfile/get', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const buyerPostInentoryProfilePost = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/sellerPostInventoryProfile/save', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const myBids = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postInventory/bids', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        4000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const myOffersOnInvApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/rfp/v2/inventory/my_offers', data, {
    headers: {
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const confirmBuyNow = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventoryBuyNow/confirm', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const inventoryBidRejected = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/bid/rejected', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const recurrenceInventoryList = (locationId, authId, token, size, pageNumber, searchVal) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('rfp/schedulePostInventoryIfRecurring/get/reccinventory?locationId=' + `${locationId}&authId=` + `${authId}&size=` + `${size}&page=` + pageNumber + `&searchBy=${searchVal}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const deleteInvRecurrence = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/rfp/v2/reccuring/update_recc_inv', data, {
    headers: {
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const confirmBuyNowOnCPU = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventoryBuyNowCpu/confirm', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const approveAccept = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/bid/approve-accept', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const approveAcceptPostLoad = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/bid/approve-accept', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const getAllPostInventoryFavoriteAPI = (pageNo, size, sort, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postInventory/getAllFavorite?page=' + `${pageNo}` + '&size=' + `${size}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const getAllInventoryWishlist = (data, token) => (dispatch) => {
  dispatch(showAppLoader());

  return axioPath.post('/rfp/v2/products/get_all_inventory_wishlist', data, {
    headers: {
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};


export const inventoryRepost = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  // .post('/rfp/postLoad/repost', data, {
  return axioPath.post('/rfp/v2/inventory/repost', data, {
    headers: {
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const postInventoryDelete = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('rfp/v2/inventory/delete/' + `${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const postInventoryUpdate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postInventory/update', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
